var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfilePic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile_Pic",
    "data-name": "Profile Pic",
    transform: "translate(-2494.223 14153.777)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3609",
    "data-name": "Ellipse 3609",
    transform: "translate(2494.223 -14153.777)",
    fill: "none",
    stroke: "#ddd",
    strokeWidth: 1,
    strokeDasharray: 15
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 100,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 99.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3610",
    "data-name": "Ellipse 3610",
    cx: 80,
    cy: 80,
    r: 80,
    transform: "translate(2514.223 -14133.777)",
    fill: "#f5f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "communication_1_",
    "data-name": "communication (1)",
    d: "M34.269,2.335a6.557,6.557,0,0,0-1.094,13.022v5.222h2.188V15.364A6.561,6.561,0,0,0,34.269,2.333ZM6.562,16.917a6.563,6.563,0,1,0,5.491,10.148L25.11,34.736a.549.549,0,0,1-.009-.059l0-.077V32.19L12.928,25.037a6.529,6.529,0,0,0-6.366-8.12Zm56.875,0a6.548,6.548,0,0,0-6.208,8.673l-13.173,7.47v1.531a7.011,7.011,0,0,1-.147,1.068l14.361-8.142a6.56,6.56,0,1,0,5.167-10.6ZM26.416,21.31a.82.82,0,0,0-.593.772v5.563a3.149,3.149,0,0,0,1.461,2.64v4.239a7.235,7.235,0,0,0,2.5,5.379,3.574,3.574,0,0,1-1.592,2.645,22.367,22.367,0,0,1-4.239,2.093,12.813,12.813,0,0,0-4.694,3.008,9.268,9.268,0,0,0-2.187,6.519v.547l.457.179c11.211,6.475,21.575,7.223,34.086,0l.457-.179v-.547a9,9,0,0,0-2.187-6.383,12.859,12.859,0,0,0-4.648-2.87,19.868,19.868,0,0,1-4.191-2.093,3.934,3.934,0,0,1-1.641-3.465,6.47,6.47,0,0,0,2.461-4.834V27.413a4.512,4.512,0,0,0-4.375-4.646h-8.75a2.632,2.632,0,0,1-1.094-.179c-.182-.1-.227-.116-.227-.5a.836.836,0,0,0-1-.777Zm8.157,21.271a2.137,2.137,0,0,1,2.135,2.137,2.205,2.205,0,0,1-.645,1.564s-.532.254-.3,1.107l1.728,9.673-2.916,1.457-2.859-1.474,1.761-9.656a.982.982,0,0,0-.313-1.107,2.061,2.061,0,0,1-.726-1.564A2.136,2.136,0,0,1,34.573,42.581ZM53,48.59a11.332,11.332,0,0,1,1.054,3.157l3.128,1.837a6.6,6.6,0,1,0,1-1.945ZM6.562,49a6.588,6.588,0,1,0,6.169,4.344l2.325-1.319a12.132,12.132,0,0,1,.831-2.986l-4.228,2.4A6.562,6.562,0,0,0,6.562,49Z",
    transform: "translate(2559.223 -14086.006)",
    fill: "#474b4f",
    opacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePic);
export default __webpack_public_path__ + "static/media/ProfilePic.d8d3ccdad1393a19ac6ce17d6a2ddcea.svg";
export { ForwardRef as ReactComponent };